import { Action } from 'common/actions/models/Action/action'
import { getActionName, getActionValue } from 'common/actions/selectors/actionsSelectors'
import { FlowChartAction } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartActionNode'

export const getActionNodeAction = (
  action: Action,
  builderId: string,
  state: RootState,
): FlowChartAction => {
  return {
    name: getActionName(state, action),
    description: getActionValue(state, action, builderId),
  }
}
